import { customWidgetWidth, customWidgetHeight } from '../index';

export const defaultSize = {
    width: 620,
    height: 362,
    heightPortrait: 533
};
const minLandscapeWidth = 480; // corresponds to 30em with 16 px font

export function width() {
    if (customWidgetWidth) return customWidgetWidth;

    if (typeof window === 'undefined') {
        return defaultSize.width;
    }
    return window.innerWidth > 0
        ? Math.min(defaultSize.width, window.innerWidth)
        : defaultSize.width;
}

export function isPortrait() {
    return width() < minLandscapeWidth;
}

export function height(displayServiceFooter) {
    if (customWidgetHeight) return customWidgetHeight;

    let def = isPortrait() ? defaultSize.heightPortrait : defaultSize.height;
    if (displayServiceFooter) def += isPortrait() ? 32 : 24;
    if (typeof window === 'undefined') {
        return def;
    }
    return def;
}

function emToPixels() {
    if (typeof document === 'undefined') {
        return 16;
    }
    const font = getComputedStyle(document.getElementById('root')).fontSize;
    return parseFloat(font || '16');
}

export function widthEm() {
    return width() / emToPixels();
}

export function heightEm() {
    return height() / emToPixels();
}
